// config.js
const BASE_URL = 'https://erp.caci.dz';
//  const BASE_URL = 'http://127.0.0.1:8000';
//const BASE_URL = 'http://127.0.0.1:4000';
export default BASE_URL;
